import React, { useState } from 'react'
import Navigation from './Navigation'
import ResponsiveTable from './ResponsiveTable'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { clearCart } from '../Slices/cart/Cart';
import { Navigate, Link } from 'react-router-dom'
import PaypalPayment from './PaypalPayment';
import { FiShoppingBag, FiTruck, FiCreditCard, FiShield, FiArrowLeft } from 'react-icons/fi';
import { MdLocalShipping, MdPayment, MdSecurity, MdShoppingCart } from 'react-icons/md';

function Cart() {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const userId = localStorage.getItem('userId');
  let subTotal = 0;
  const [shipping] = useState(localStorage.getItem('zone_price') ? localStorage.getItem('zone_price') : 0);
  const [isProcessing, setIsProcessing] = useState(false);
  
  cart.forEach(item => {
    subTotal += parseFloat(item.unitsaleprice * item.qty);
  });
  
  const token = localStorage.getItem('token');
  const itemCount = cart.reduce((acc, item) => acc + item.qty, 0);

  if (!token) {
    return <Navigate to='/login' />
  }

  const handleSaveReciept = () => {
    setIsProcessing(true);
    
    const data = {
      letter: cart,
      ppcell: userId,
      recovery: 0,
      ppadvance: 0,
      sales_tex_percent: 0,
      shipping: shipping,
      supergrandtotal: parseFloat(shipping + subTotal).toFixed(2),
      discount: 0,
      salesTaxAmount: 0,
      entercash: 0,
      paymentType: 'Card'
    };

    if (data.letter.length > 0 && data.ppcell !== "") {
      axios.post("/api/post/online/store/entrysale", data).then((res) => {
        console.log(res);
        if (res.data.status === 'ok') {
          toast.success("Your order placed wait for response", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          dispatch(clearCart());
        } else {
          toast.warning("Something went wrong", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        setIsProcessing(false);
      }).catch(() => {
        setIsProcessing(false);
      });
    } else {
      toast.warn("Cart should not be empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setIsProcessing(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <Navigation name="Cart" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Cart Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg">
              <MdShoppingCart className="text-white text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                Shopping Cart
              </h1>
              <p className="text-gray-500 text-sm">
                {itemCount} {itemCount === 1 ? 'item' : 'items'} in your cart
              </p>
            </div>
          </div>
        </div>

        {cart.length === 0 ? (
          /* Empty Cart State */
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-12 text-center">
            <div className="flex flex-col items-center gap-4">
              <div className="p-6 bg-gray-100 rounded-full">
                <FiShoppingBag size={64} className="text-gray-400" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800">Your cart is empty</h2>
              <p className="text-gray-500">Looks like you haven't added any items yet</p>
              <Link
                to="/"
                className="mt-4 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all inline-flex items-center gap-2"
              >
                <FiArrowLeft size={18} />
                Continue Shopping
              </Link>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            {/* Cart Items Section */}
            <div className="lg:col-span-7">
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                <ResponsiveTable cart={cart} status='cart' />
              </div>
              
              <div className="mt-6">
                <Link
                  to="/"
                    className="inline-flex items-center gap-2 px-5 py-2.5 text-gray-600 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 transition-all"
                  >
                    <FiArrowLeft size={16} />
                    Continue Shopping
                  </Link>
              </div>
            </div>

            {/* Order Summary Section */}
            <div className="lg:col-span-5">
              <div className="sticky top-6">
                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                  {/* Summary Header */}
                  <div className="bg-gradient-to-r from-gray-800 to-gray-900 px-6 py-4">
                    <h2 className="text-lg font-bold text-white flex items-center gap-2">
                      <FiCreditCard size={20} />
                      Order Summary
                    </h2>
                  </div>

                  <div className="p-6 space-y-4">
                    {/* Subtotal */}
                    <div className="flex justify-between items-center pb-4 border-b border-gray-100">
                      <span className="text-gray-600">Subtotal</span>
                      <span className="text-lg font-semibold text-gray-800">
                        Rs{subTotal.toFixed(2)}
                      </span>
                    </div>

                    {/* Shipping */}
                    <div className="flex justify-between items-start pb-4 border-b border-gray-100">
                      <div className="flex items-start gap-2">
                        <FiTruck className="text-gray-400 mt-0.5" />
                        <div>
                          <span className="text-gray-600 block">Shipping</span>
                          <span className="text-xs text-gray-400">Delivery charges apply</span>
                        </div>
                      </div>
                      <span className="text-gray-800 font-medium">
                        Rs{parseFloat(shipping).toFixed(2)}
                      </span>
                    </div>

                    {/* Total */}
                    <div className="flex justify-between items-center pt-2">
                      <div>
                        <span className="text-lg font-bold text-gray-800">Total</span>
                        <p className="text-xs text-gray-400">Including all taxes</p>
                      </div>
                      <div className="text-right">
                        <span className="text-2xl font-bold text-blue-600">
                         Rs {(parseFloat(shipping) + parseFloat(subTotal)).toFixed(2)}
                        </span>
                        <p className="text-xs text-gray-400">Rupees</p>
                      </div>
                    </div>

                    {/* Payment Buttons */}
                    <div className="space-y-3 mt-6">
                      {subTotal === 0 ? (
                        <button 
                          className='w-full py-3.5 bg-gray-800 text-white rounded-xl font-semibold hover:bg-gray-900 transition-all'
                        >
                          Add to Quote
                        </button>
                      ) : (
                        <>
                          <button 
                            className='w-full py-3.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed'
                            onClick={handleSaveReciept}
                            disabled={isProcessing}
                          >
                            {isProcessing ? (
                              <>
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                Processing...
                              </>
                            ) : (
                              <>
                                <FiTruck size={18} />
                                Cash On Delivery
                              </>
                            )}
                          </button>

                          <div className="relative">
                            <div className="absolute inset-0 flex items-center">
                              <div className="w-full border-t border-gray-200"></div>
                            </div>
                            <div className="relative flex justify-center text-sm">
                              <span className="px-2 bg-white text-gray-500">OR</span>
                            </div>
                          </div>

                          <PaypalPayment onButtonClick={handleSaveReciept} />
                        </>
                      )}
                    </div>

                    {/* Trust Badges */}
                    <div className="mt-6 pt-4 border-t border-gray-100">
                      <div className="grid grid-cols-3 gap-2 text-center">
                        <div className="p-2">
                          <MdSecurity className="mx-auto text-gray-400 text-lg mb-1" />
                          <p className="text-xs text-gray-500">Secure Payment</p>
                        </div>
                        <div className="p-2">
                          <MdLocalShipping className="mx-auto text-gray-400 text-lg mb-1" />
                          <p className="text-xs text-gray-500">Fast Delivery</p>
                        </div>
                        <div className="p-2">
                          <MdPayment className="mx-auto text-gray-400 text-lg mb-1" />
                          <p className="text-xs text-gray-500">Easy Returns</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Shipping Info Card */}
                <div className="mt-6 p-4 bg-blue-50 rounded-xl border border-blue-100">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-white rounded-lg shadow-sm">
                      <FiShield className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-800">Delivery Information</p>
                      <p className="text-xs text-gray-600 mt-1">
                        Estimated delivery: 3-5 business days<br />
                        Free shipping on orders over $100
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Cart